import { supabase } from '@/lib/supabase';
import type { User, UpdateUserProfile } from '@sharecost/shared';

export async function fetchUserProfile(userId: string): Promise<User | null> {
  const { data, error } = await supabase
    .from('users')
    .select('*')
    .eq('id', userId)
    .single();

  if (error) return null;
  return data as User;
}

export async function updateUserProfile(userId: string, updates: UpdateUserProfile): Promise<void> {
  const dbUpdates: Record<string, unknown> = {};
  if (updates.name !== undefined) dbUpdates.display_name = updates.name;
  if (updates.avatarUrl !== undefined) dbUpdates.avatar_url = updates.avatarUrl;
  if (updates.defaultCurrency !== undefined) dbUpdates.default_currency = updates.defaultCurrency;
  if (updates.timezone !== undefined) dbUpdates.timezone = updates.timezone;
  if (updates.weekStartDay !== undefined) dbUpdates.week_start_day = updates.weekStartDay;
  if (updates.monthStartDay !== undefined) dbUpdates.month_start_day = updates.monthStartDay;
  if (updates.payment_methods !== undefined) dbUpdates.payment_methods = updates.payment_methods;
  if (updates.payment_qr_enabled !== undefined) dbUpdates.payment_qr_enabled = updates.payment_qr_enabled;

  const { error } = await supabase
    .from('users')
    .update(dbUpdates)
    .eq('id', userId);

  if (error) throw error;
}
